export interface PartnerRedirects {
  completeRedirectURL?: string;
  terminateRedirectURL?: string;
  overQuotaRedirectURL?: string;
  qcRedirectURL?: string;
}